import { render, staticRenderFns } from "./Processar.vue?vue&type=template&id=11b0efb4"
import script from "./Processar.vue?vue&type=script&lang=ts"
export * from "./Processar.vue?vue&type=script&lang=ts"
import style0 from "./Processar.vue?vue&type=style&index=0&id=11b0efb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports